export default __webpack_public_path__ + "static/top-five-46ba6d164b5ac6c0cc02adfb00893bb9.svg";